// views/alert/AlertListView.tsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "@/store/loadingStore";
import { useModal } from "@/store/modalStore";

interface AlertData {
  id: number;
  measurementDate: string;
  location: string;
  district: string;
  eventType: string;
  temperature: number;
  humidity: number;
  ammonia: number;
  tvoc: number;
  manager: string;
  contact: string;
  status: string;
}

const ComplaintView = () => {
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoading();
  const modal = useModal();

  // 상태 관리
  const [alerts, setAlerts] = useState<AlertData[]>([]);
  const [selectedAlerts, setSelectedAlerts] = useState<number[]>([]);
  const [province, setProvince] = useState("전라남도");
  const [city, setCity] = useState("나주시");
  const [district, setDistrict] = useState("빛가람동");
  const [filterDate, setFilterDate] = useState("2025-03-20");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize] = useState(10);

  // 통계 정보
  const [stats, setStats] = useState({
    alarm: 36,
    notification: 24,
    processed: 12,
  });

  // 선택된 알림 정보
  const [selectedAlert, setSelectedAlert] = useState<AlertData | null>(null);

  // 더미 데이터
  const dummyData: AlertData[] = [
    {
      id: 1,
      measurementDate: "2025-03-20 12:30",
      location: "빛가람동",
      district: "청송리돈사",
      eventType: "매우나쁨",
      temperature: 8.23,
      humidity: 1.07,
      ammonia: 1.05,
      tvoc: 157.67,
      manager: "최우식",
      contact: "010-4822-3645",
      status: "대기",
    },
    {
      id: 2,
      measurementDate: "2025-03-20 12:30",
      location: "빛가람동",
      district: "청송리돈사",
      eventType: "매우나쁨",
      temperature: 8.23,
      humidity: 1.07,
      ammonia: 1.05,
      tvoc: 157.67,
      manager: "최우식",
      contact: "010-4822-3645",
      status: "대기",
    },
    {
      id: 3,
      measurementDate: "2025-03-20 12:30",
      location: "빛가람동",
      district: "청송리돈사",
      eventType: "매우나쁨",
      temperature: 8.23,
      humidity: 1.07,
      ammonia: 1.05,
      tvoc: 157.67,
      manager: "최우식",
      contact: "010-4822-3645",
      status: "대기",
    },
    {
      id: 4,
      measurementDate: "2025-03-20 12:30",
      location: "빛가람동",
      district: "청송리돈사",
      eventType: "매우나쁨",
      temperature: 8.23,
      humidity: 1.07,
      ammonia: 1.05,
      tvoc: 157.67,
      manager: "최우식",
      contact: "010-4822-3645",
      status: "처리완료",
    },
    {
      id: 5,
      measurementDate: "2025-03-20 12:30",
      location: "빛가람동",
      district: "청송리돈사",
      eventType: "매우나쁨",
      temperature: 8.23,
      humidity: 1.07,
      ammonia: 1.05,
      tvoc: 157.67,
      manager: "최우식",
      contact: "010-4822-3645",
      status: "처리완료",
    },
  ];

  // 데이터 로드
  useEffect(() => {
    loadAlerts();
  }, [currentPage, filterDate]);

  const loadAlerts = async () => {
    try {
      // 실제 API 호출 대신 더미 데이터 사용
      setAlerts(dummyData);
      setTotalPages(5);
      setTotalElements(50);
      updateStats();
    } catch (error) {
      modal.alert("오류", "알림 목록을 불러오는데 실패했습니다.");
    }
  };

  const updateStats = () => {
    setStats({
      alarm: 36,
      notification: 24,
      processed: 12,
    });
  };

  // 검색
  const handleSearch = async () => {
    loadAlerts();
  };

  // 행 클릭시 상세 정보 표시
  const handleRowClick = (alert: AlertData) => {
    setSelectedAlert(alert);
  };

  // 엑셀 다운로드
  const handleExcelDownload = async () => {
    try {
      startLoading("엑셀 파일 생성 중...");
      // await downloadAlertsExcelApi();
    } catch (error) {
      modal.alert("오류", "엑셀 다운로드 중 오류가 발생했습니다.");
    } finally {
      stopLoading();
    }
  };

  // 처리완료 처리
  const handleProcess = () => {
    // 처리 로직
    modal.alert("완료", "처리가 완료되었습니다.");
  };

  // 문자 발송
  const handleSendSMS = () => {
    window.open("tel:" + selectedAlert?.contact);
  };

  return <div className="alert-list-container"></div>;
};

export default ComplaintView;
